import { render, staticRenderFns } from "./GasMetric.vue?vue&type=template&id=64e29614&scoped=true&"
import script from "./GasMetric.vue?vue&type=script&lang=js&"
export * from "./GasMetric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e29614",
  null
  
)

export default component.exports